import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DealsPaymentService {

  [x: string]: any;

  constructor(private http: HttpClient) { }

  url = environment.serverAPI9 + "/api/dealspayments";

  url1 = environment.serverAPI9 + "/api/deals";

  newdealspayments(dealspayments: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}`, dealspayments)
  }

  addpayment(kitchenMaster: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url1}/payments`, kitchenMaster)
  }


  dealspayments(Page: number, size: number, sort): Observable<Object> {
    return this.http.get(`${this.url}?page=${Page}&size=${size}&sort=${sort}`);
  }

  dealspaymentsSearch(query: any, Page: any, size: any, sort: any): Observable<Object> {

    return this.http.get(`${this.url}/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}`);
  }

  deleteImage(data: any): Observable<Object> {
    return this.http.post(`${this.url}/deleteImage`, data);
  }
  getAllPaymentModeDropDown(): Observable<Object> {

    let authourized = this.loginService.getAuthenticatedUser();
    if (authourized) {
      return this.http.get(`${this.url}/dropdown`);
    } else {
      return this.http.get(`${this.url}/ig/dropdown`);
    }

  }



}
